// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class ActingProfileEthnicity extends TrackingModel {
	public ActingProfileEthnicityId: number = 0;
	public ActingProfileId: number = 0;
	public EthnicityId: number = 0;
}